export const SET_SUPPLIERS = 'SET_SUPPLIERS';
export const SET_SUPPLIER = 'SET_SUPPLIER';
export const ADD_SUPPLIER = 'ADD_SUPPLIER';
export const UPDATE_SUPPLIER = 'UPDATE_SUPPLIER';
export const REMOVE_SUPPLIER = 'REMOVE_SUPPLIER';
export const CLEAR_SUPPLIER = 'CLEAR_SUPPLIER';
export const CLEAR_SUPPLIERS = 'CLEAR_SUPPLIERS';
